<template>
  <el-dialog
    class="tips-dialog"
    title="什么是原创文章"
    :show-close="false"
    :visible.sync="flag"
    width="722px"
    center
  >
    <div>
      <p class="before-content-color title">
        <span class="before-icon"></span> 对患者有帮助
      </p>
      <p class="dialog-content">
        原创是指自己写的或团队自制、独立完成的作品，并对该内容有合法版权。抄袭或剽窃他人作品，汇总再编辑的文章，营销推广的内容，非独家授权或代理的作品，都不算原创内容。
      </p>
      <p class="dialog-content">
        作者对内容的真实性、准确性负责，拥有内容中展示照片的合法版权。产生的后果作者需全部自行承担。
      </p>
    </div>
    <div slot="footer" class="dialog-footer btns dialog-but">
      <el-button type="primary" @click="$emit('handleClose')">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "originalTipsDialog",
  props: ['originalTips'],
  computed: {
    flag: {
      get() {
        return this.originalTips
      },
      set(val) {
        this.$emit('update:originalTips',val)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
.btns{
  padding-bottom: 22px;
  padding-top: 9px;
  line-height: 0px !important;
}
</style>
